import React from "react";
import "../styles/Map.css";

// Import your wheel icon and images
import wheelIcon from "../assets/icons/map-icon.png";
import bannerImage from "../image/map-image.png";
import routeMapImage from "../image/map.jpg";

const Map = () => {
  // Port locations matching the yellow dots in your map image
  // Adjust these coordinates to precisely match your image dots
  const ports = [
    // Top right cluster (Japan)
    { name: "Fukuyama", top: "17%", left: "84%" },
    { name: "Mizushima", top: "18%", left: "84.5%" },
    { name: "Hitachinaka", top: "17.5%", left: "87%" },
    { name: "Yokohama", top: "18%", left: "87.5%" },
    { name: "Shimizu", top: "19.5%", left: "85%" },
    { name: "Chiba", top: "19%", left: "87%" },
    { name: "Kisarazu", top: "19.5%", left: "87.5%" },
    { name: "Kobe", top: "21%", left: "85%" },
    { name: "Tokuyama", top: "21%", left: "87%" },
    
    // Korea
    { name: "Pohang", top: "19%", left: "80%" },
    { name: "Onsan", top: "19.5%", left: "80.5%" },
    
    // China/Taiwan area
    { name: "Kaohsiung", top: "25%", left: "77%" },
    { name: "Hong Kong", top: "28%", left: "74%" },
    { name: "Haiphong", top: "31%", left: "74.5%" },
    { name: "Shekou", top: "27%", left: "73%" },
    { name: "Chiwan", top: "27.5%", left: "73.5%" },
    { name: "Yantian", top: "29%", left: "74%" },
    
    // Southeast Asia cluster
    { name: "Ho Chi Minh", top: "35%", left: "74%" },
    { name: "Bangkok", top: "39%", left: "68%" },
    { name: "Laem Chabang", top: "40%", left: "68.5%" },
    { name: "Port Kelang", top: "47%", left: "68%" },
    { name: "Singapore", top: "54%", left: "69%" },
    { name: "Belawan", top: "55%", left: "67%" },
    { name: "Jakarta", top: "60%", left: "72%" },
    { name: "Surabaya", top: "56%", left: "78%" },
    { name: "Balikpapan", top: "52%", left: "81%" },
    { name: "Bankok", top: "53%", left: "82%" },
    
    // Philippines
    { name: "Manila", top: "42%", left: "81%" },
    { name: "Cebu", top: "46%", left: "82%" },
    
    // India
    { name: "Mumbai", top: "36%", left: "53%" },
    { name: "Mundra", top: "34%", left: "52%" },
    { name: "Hazira", top: "35%", left: "53%" },
    { name: "Kandla", top: "33%", left: "52%" },
    { name: "Pipavav", top: "35.5%", left: "52.5%" },
    { name: "Nhava Sheva", top: "36.5%", left: "53.5%" },
    { name: "Chennai", top: "42%", left: "60%" },
    { name: "Ennore", top: "41.5%", left: "60.5%" },
    { name: "Kattupalli", top: "41%", left: "60%" },
    { name: "Vizag", top: "38%", left: "61%" },
    { name: "Paradeep", top: "36%", left: "62%" },
    
    // Middle East
    { name: "Jebel Ali", top: "28%", left: "42%" },
    { name: "Dammam", top: "26%", left: "40%" },
    { name: "Shuwaikh", top: "25%", left: "39%" },
    { name: "Shuaiba", top: "25.5%", left: "39.5%" },
    
    // Africa
    { name: "Naaboudhi", top: "48%", left: "23%" },
    { name: "Walvis Bay", top: "70%", left: "21%" },
    { name: "Maputo", top: "76%", left: "27%" },
    { name: "Durban", top: "80%", left: "28%" },
    { name: "Tanga", top: "62%", left: "30%" },
  ];

  return (
    <div className="map-container">
      {/* Image Slider */}
      <div className="map-image-slider">
        <img src={bannerImage} alt="Map Banner" />
      </div>

      {/* Header with icon */}
      <div className="map-header">
        <img src={wheelIcon} alt="Ship Wheel" className="map-wheel-icon" />
        <span className="map-title">Map</span>
      </div>
      
      {/* Map Image with Animated Overlay */}
      <div className="map-image-container">
        <div className="map-wrapper">
          <img 
            src={routeMapImage} 
            alt="ECL Shipping Route Map" 
            className="map-route-image"
          />
          {/* Blinking Overlay on existing dots */}
          <div className="blink-overlay">
            {ports.map((port, index) => (
              <div
                key={index}
                className="blink-point"
                style={{ 
                  top: port.top, 
                  left: port.left,
                  animationDelay: `${(index * 0.1) % 1.5}s` // Staggered animation
                }}
                title={port.name}
              >
                <div className="glow-effect"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
      
      {/* Description Text */}
      <div className="map-description">
        <p>
          ECL Shipping provides comprehensive shipping services connecting major ports across India, East Asia, Southeast Asia, 
          and the Far East. Our routes include connections between key locations such as Mumbai, Chennai, Kolkata, Singapore, 
          Hong Kong, Tokyo, and many more strategic ports throughout the region.
        </p>
      </div>
    </div>
  );
};

export default Map;